class TimeIntervalSplitter {
  constructor(startTime, endTime, n) {
    console.log('zzz', startTime, endTime, n);
    this.startTime = this.parseDateTime(startTime);
    this.endTime = this.parseDateTime(endTime);
    this.n = n;
    this.intervalLength = (this.endTime - this.startTime) / n;
  }

  parseDateTime(dateTimeStr) {
    const [datePart, timePart] = dateTimeStr.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours = 0, minutes = 0, seconds = 0] = (timePart || '').split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds).getTime();
  }

  formatDateTime(timestamp) {
    const date = new Date(timestamp);
    const pad = num => num.toString().padStart(2, '0');

    return [
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    ].join(' ');
  }

  getTimeRange(input) {
    if (!Array.isArray(input)) {
      if (input < 0 || input > this.n) {
        throw new Error(`输入值必须在 0 到 ${this.n} 的范围内`);
      }

      const start = this.startTime + input * this.intervalLength;
      const end = this.startTime + (input + 1) * this.intervalLength;
      return [this.formatDateTime(start), this.formatDateTime(end)];
    } else {
      if (input.length !== 2) {
        throw new Error('数组输入必须包含两个元素 [x1, x2]');
      }

      const [x1, x2] = input;
      if (x1 < 0 || x2 > this.n || x1 > x2) {
        throw new Error(`输入值必须满足 0 ≤ x1 ≤ x2 ≤ ${this.n}`);
      }

      const start = this.startTime + x1 * this.intervalLength;
      const end = this.startTime + x2 * this.intervalLength;
      return [this.formatDateTime(start), this.formatDateTime(end)];
    }
  }
}

// 导出类以便其他文件可以使用
export default TimeIntervalSplitter;
